import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface ContextualLinkProps {
  to: string;
  children: ReactNode;
  className?: string;
}

const ContextualLink = ({ to, children, className = '' }: ContextualLinkProps) => {
  return (
    <Link
      to={to}
      onClick={() => window.scrollTo(0, 0)}
      className={`text-[#0a2540] font-medium underline decoration-[#f39aa2] decoration-1 underline-offset-4 hover:text-[#f39aa2] transition-colors duration-300 ${className}`}
    >
      {children}
    </Link>
  );
};

export default ContextualLink;
